<template>
  <div class="preview-section" @mouseenter="$emit('show')" @mouseleave="$emit('hide')">
    <div class="selected-values">
      <span class="selected-count">{{ selectedCount }}</span>
      <div class="selected-labels">
        {{ selectedLabels }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewSection',
  props: {
    selectedCount: {
      type: Number,
      required: true
    },
    selectedLabels: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-section {
  cursor: pointer;

  .selected-values {
    background: #ffffff;
    padding: 8px 12px;
    border-radius: 6px;
    border: 1px solid #e1e1e1;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;

    &:hover {
      border-color: var(--accent-color, #ff607d);
    }

    .selected-count {
      background: var(--accent-color, #ff607d);
      color: white;
      font-size: 12px;
      padding: 2px 8px;
      border-radius: 12px;
      font-weight: 500;
    }

    .selected-labels {
      font-size: 12px;
      color: #666;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 1px;
    }
  }
}
</style>
